import { API_ROUTES } from '@/constants/apiRoutes';
import { PaginatedApiResponse } from '@/react-query/context/ApiClientContextController';
import { queryFactoryOptions } from '@/react-query/utills/queryFactoryOptions';
import { AxiosInstance } from 'axios';
import { GetHostDetailsParams, GetHostListParams, HostListItem, HostManagement } from './hostManagement.types';

export const getHostList = (client: AxiosInstance) => async (params?: GetHostListParams) => {
  return (await client.get<PaginatedApiResponse<HostListItem[]>>(API_ROUTES.GET_HOST_LIST, { params })).data;
};

export const getHostDetails = (client: AxiosInstance) => async (params?: GetHostDetailsParams) => {
  return (await client.get<PaginatedApiResponse<HostManagement[]>>(API_ROUTES.GET_HOST_DETAILS, { params })).data;
};

export const hostListQueries = {
  all: () => ['hostList'],
  list: (params?: GetHostListParams) =>
    queryFactoryOptions<PaginatedApiResponse<HostListItem[]>>({
      queryKey: [...hostListQueries.all(), 'list', params],
      queryFn: (client: AxiosInstance) => () => getHostList(client)(params),
    }),
  detail: (clubId = '', hostCode = '') =>
    queryFactoryOptions<PaginatedApiResponse<HostManagement[]>>({
      queryKey: [...hostListQueries.all(), 'detail', clubId, hostCode],
      queryFn: (client: AxiosInstance) => () => getHostDetails(client)({ clubId, hostCode }),
    }),
};
